//react
import React from 'react';
import ReactDOM from 'react-dom';
//material-ui
import { ThemeProvider } from '@material-ui/core/styles';
//best
//import App from './App';
import * as serviceWorker from './serviceWorker';
import BestTheme from './BestTheme'
import Best from './Best'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={BestTheme}>
      <Best name = 'Beta Estimate'/>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
